export default "__VITE_ASSET__dea6d0a1__"